import "core-js/stable";
import "regenerator-runtime/runtime";
// Import Component hooks before component definitions
import './component-hooks';
import Vue from 'vue';
import './plugins/vuetify';
import './plugins/vee-validate';
import App from './App.vue';
import router from './router';
import store from '@/store';
import './registerServiceWorker';
import 'vuetify/dist/vuetify.min.css';
import vuetify from './plugins/vuetify';
import http from './plugins/http';
import i18n from './i18n';
import Vuelidate from 'vuelidate';
import VueKonva from 'vue-konva'

Vue.config.productionTip = false;
//Vue.use(http);
Vue.use(Vuelidate)
Vue.use(VueKonva)

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
